import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { EmojiPeople } from '@mui/icons-material';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  ListItem,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material';
import { SectionTitleFontSize } from '../HomeView';

/** The social proof component shows reviews we've received from various people on the home page */
const SocialProofSection = () => {
  const theme = useTheme();

  /** Reviews we've received */
  const reviews = [
    {
      feedback:
        'Jim and his team at S3G have created a superior on-line training platform that takes its participants through the steps needed to survive a deadly force encounter, feel safe in our workspaces and most importantly how to stop a problem before it becomes one.',
      image: 'https://assets.maccarianagency.com/avatars/img3.jpg',
      name: 'Joe Fortunato',
      title: 'Partner, Vice President',
    },
    {
      feedback:
        'The lessons and instructions I received from S3G Security over the years have undoubtedly saved my life time and time again.',
      image: 'https://assets.maccarianagency.com/avatars/img3.jpg',
      name: 'Jason Vernon',
      title: 'Law Enforcement',
    },
    {
      feedback:
        'Jim has unique training and knowledge in human response to stress and pressure and intertwines it into his program deliveries. His training is a must for any school, university or business.',
      image: 'https://assets.maccarianagency.com/avatars/img3.jpg',
      name: 'David Mantica',
      title: 'VP and General Manager',
    },
    {
      feedback:
        'After the Sandy Hook mass murder and several incidences impacting our own school, the administrators came to ask my opinion as to how best begin the process of educating educators. When asked, I answered unequivocally that the person to turn to was Jim Warwick and S3G Security.',
      image: 'https://assets.maccarianagency.com/avatars/img3.jpg',
      name: 'Jennifer Powell',
      title: 'Esquire',
    },
    {
      feedback:
        'The training S3G Security provided our security team and church has been outstanding. We feel very fortunate to have found someone with Jim’s background, training, and professionalism as a resource.',
      image: 'https://assets.maccarianagency.com/avatars/img2.jpg',
      name: 'Middletown Baptist Church',
      title: 'Security Team',
    },
    {
      feedback:
        "Attending S3G Security's Active Shooter and Situational Awareness training has emboldened me and given me the confidence I need to survive in today's world of uncertainty.",
      image: 'https://assets.maccarianagency.com/avatars/img3.jpg',
      name: 'Debbie Geiser',
      title: 'Nurse',
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ padding: '3em .5em' }}>
      <Grid container spacing={0.5}>
        <Grid item xs={12}>
          <Typography
            variant="h3"
            fontWeight="700"
            fontSize={SectionTitleFontSize}
            textAlign="center"
            marginBottom=".5em"
          >
            Trusted by Professionals Across Industries
          </Typography>
        </Grid>

        {reviews.map((item, i) => (
          <Grid key={i} item xs={12} md={6}>
            <Box height="100%" padding={{ xs: 0, sm: 1, md: 2 }}>
              <Card
                elevation={0}
                sx={{
                  height: '100%',
                  border: `1px solid ${theme.palette.divider}`,
                }}
              >
                <CardContent
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-evenly',
                  }}
                >
                  <Typography variant="h6" fontWeight={400} marginBottom={2}>
                    {item.feedback}
                  </Typography>
                  <Box width={1} display="flex" justifyContent="space-between">
                    <ListItem disableGutters sx={{ width: 'auto', padding: 0 }}>
                      <Box
                        sx={{
                          borderRadius: '50%',
                          height: '50px',
                          width: '50px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '1em',
                          '@keyframes animatedBorder': {
                            '0%': {
                              backgroundPosition: '0% 50%',
                            },
                            '50%': {
                              backgroundPosition: '100% 50%',
                            },
                            '100%': {
                              backgroundPosition: '0% 50%',
                            },
                          },
                          background:
                            'linear-gradient(-70deg, #c2185b, #512da8, #1976d2, #0097a7)',
                          backgroundSize: '400% 400%',
                          animation: 'animatedBorder 10s ease infinite',
                        }}
                      >
                        <Box
                          sx={{
                            height: '45px',
                            width: '45px',
                            backgroundColor:
                              theme.palette.mode === 'light'
                                ? 'white'
                                : '#383838',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <EmojiPeople
                            sx={{
                              color: theme.palette.secondary.main,
                              fontSize: '1.8em',
                            }}
                          />
                        </Box>
                      </Box>
                      <ListItemText
                        primary={item.name}
                        secondary={item.title}
                        sx={{ margin: 0 }}
                      />
                    </ListItem>
                    <Box marginBottom={1}>
                      {[1, 2, 3, 4, 5].map((i) => (
                        <StarRoundedIcon
                          key={i}
                          sx={{ color: 'rgb(255 196 0)' }}
                        />
                      ))}
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default SocialProofSection;
